
import './shopInfo.css'

const ShopInfo = ({ info = {} }) => { 

  return (
    <div className="shop-info">
      {/* 第一行：本地数据 */}
      <div className="shop-info-row">
        <div className="row-header">
          <div className={`header-label ${info.localDataFailed ? 'rest' : ''}`}>
            本地
            {info.localDataFailed && <div className="rest-status">(休息中)</div>}
          </div>
        </div>
        <div className="divider-vertical"></div>
        <div className="data-item">
          <div className="label">昨日单数</div>
          <div className="value">{!info.localDataFailed && info.local_yesterday_order_num !== undefined ? info.local_yesterday_order_num : ""}</div>
        </div>
        <div className="divider-vertical"></div>
        <div className="data-item">
          <div className="label">昨日营业</div>
          <div className="value">{!info.localDataFailed && info.local_yesterday_turnover ? info.local_yesterday_turnover : ""}</div>
        </div>
        <div className="divider-vertical"></div>
        <div className="data-item">
          <div className="label">今日单数</div>
          <div className="value">{!info.localDataFailed && info.local_today_order_num !== undefined ? info.local_today_order_num : ""}</div>
        </div>
        <div className="divider-vertical"></div>
        <div className="data-item">
          <div className="label">今日营业</div>
          <div className="value">{!info.localDataFailed && info.local_today_turnover ? info.local_today_turnover : ""}</div>
        </div>
      </div>
      
      {/* 分隔线 */}
      <div className="divider-horizontal"></div>
      
      {/* 第二行：电子票数据 */}
      <div className="shop-info-row">
        <div className="row-header">
          <div className="header-label">电子票</div>
        </div>
        <div className="divider-vertical"></div>
        <div className="data-item">
          <div className="label">昨日单数</div>
          <div className="value">{info.electronic_yesterday_order_num !== undefined ? info.electronic_yesterday_order_num : 0}</div>
        </div>
        <div className="divider-vertical"></div>
        <div className="data-item">
          <div className="label">昨日营业</div>
          <div className="value">{info.electronic_yesterday_turnover ? info.electronic_yesterday_turnover : 0}</div>
        </div>
        <div className="divider-vertical"></div>
        <div className="data-item">
          <div className="label">今日单数</div>
          <div className="value">{info.electronic_today_order_num !== undefined ? info.electronic_today_order_num : 0}</div>
        </div>
        <div className="divider-vertical"></div>
        <div className="data-item">
          <div className="label">今日营业</div>
          <div className="value">{info.electronic_today_turnover ? info.electronic_today_turnover : 0}</div>
        </div>
      </div>
    </div>
  );
};


export default ShopInfo;
